import * as React from "react";
import styled from "styled-components";

import logo from "../assets/logo.jpeg";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  height: 60px;
  width: 100%;
  background-color: white;
  border-bottom: 1px solid #eee;
  img {
    height: 59px;
    cursor: pointer;
  }
`;

const PageHeader: React.FunctionComponent = () => {
  const navigate = useNavigate();
  return (
    <Container className="headerComp">
      <img
        src={logo}
        alt=""
        onClick={() => {
          navigate("./");
        }}
      />
    </Container>
  );
};

export default PageHeader;
